document.addEventListener('DOMContentLoaded', () => {
  const BOOKING_FEE_VARIANT_ID = 53457796825352;
  const BOOKING_FEE_CENTS = 25;

  function formatMoney(cents) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'GBP'
    }).format(cents / 100);
  }

  function updateSummary(sectionId) {
    const wrapper = document.getElementById(`EventTicketList-${sectionId}`);
    const summary = document.getElementById(`EventTicketSummary-${sectionId}`);
    const summaryText = document.getElementById(`EventTicketSummaryText-${sectionId}`);
    const button = document.getElementById(`GetTicketsButton-${sectionId}`);

    if (!wrapper || !summary || !summaryText) return;

    let totalQty = 0;
    let totalPrice = 0;

    wrapper.querySelectorAll('.event-ticket-row__qty[data-variant-id]').forEach((select) => {
      if (select.disabled) return;

      const quantity = parseInt(select.value, 10) || 0;
      const price = parseInt(select.dataset.price, 10) || 0;

      if (quantity > 0) {
        totalQty += quantity;
        totalPrice += quantity * price;
      }
    });

    if (totalQty > 0) {
      const totalWithFees = totalPrice + (totalQty * BOOKING_FEE_CENTS);
      summary.classList.remove('hidden');
      summaryText.textContent = `${totalQty} ticket${totalQty > 1 ? 's' : ''} selected — ${formatMoney(totalWithFees)}`;
    } else {
      summary.classList.add('hidden');
      summaryText.textContent = `0 tickets selected — ${formatMoney(0)}`;
    }

    if (button && button.disabled) {
      summary.classList.add('hidden');
    }
  }

  document.querySelectorAll('.event-ticket-row__more-toggle').forEach((button) => {
    button.addEventListener('click', () => {
      const controlsId = button.getAttribute('aria-controls');
      const target = document.getElementById(controlsId);
      if (!target) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isExpanded));
      target.classList.toggle('hidden');
    });
  });

  document.querySelectorAll('.event-ticket-row__qty[data-variant-id]').forEach((select) => {
    select.addEventListener('change', () => {
      const section = select.closest('.event-ticket-box')?.querySelector('[id^="GetTicketsButton-"]');
      if (!section) return;
      updateSummary(section.dataset.sectionId);
    });
  });

  document.querySelectorAll('[id^="GetTicketsButton-"]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.disabled) return;

      const sectionId = button.dataset.sectionId;
      const wrapper = document.getElementById(`EventTicketList-${sectionId}`);
      const message = document.getElementById(`EventTicketMessage-${sectionId}`);

      if (!wrapper) return;

      if (message) {
        message.textContent = '';
        message.classList.add('hidden');
      }

      const items = [];
      let totalTicketQty = 0;

      wrapper.querySelectorAll('.event-ticket-row__qty[data-variant-id]').forEach((select) => {
        if (select.disabled) return;

        const quantity = parseInt(select.value, 10) || 0;
        const variantId = parseInt(select.dataset.variantId, 10);

        if (quantity > 0) {
          items.push({
            id: variantId,
            quantity,
            properties: {
              _event_ticket: 'true'
            }
          });
          totalTicketQty += quantity;
        }
      });

      if (!items.length) {
        if (message) {
          message.textContent = 'Please select at least one ticket.';
          message.classList.remove('hidden');
        }
        return;
      }

      items.push({
        id: BOOKING_FEE_VARIANT_ID,
        quantity: totalTicketQty,
        properties: {
          _booking_fee: 'true'
        }
      });

      button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || 'Could not add tickets to cart');
        }

        window.location.href = '/cart';
      } catch (error) {
        if (message) {
          message.textContent = error.message || 'There was a problem adding tickets. Please try again.';
          message.classList.remove('hidden');
        }

        button.disabled = false;
      }
    });
  });

  document.querySelectorAll('[id^="GetTicketsButton-"]').forEach((button) => {
    updateSummary(button.dataset.sectionId);
  });
});